import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../store/store';
import { CustomerUpdateDTO, SalesDTO, SalesPackage } from '../types';
import { pushPageview, pushTransaction } from '../util/GoogleTagManager';
import { RequestStatus } from '../util/RequestStatus';
import { commitSaleForCustomerAndAddress } from '../util/SalesApi';
import { routes } from '../util/utils';
import { useForm, Form } from './useForm';
import { isValidEmail, isValidPhoneNumber } from '../util/personaliaUtils';
import { updateCustomerInIcx } from '../util/SupportApi';

type Values = {
  firstName: string;
  lastName: string;
  day: string;
  month: string;
  year: string;
  email: string;
  phoneNumber: string;
};
export type PersonaliaForm = {
  form: Form<Values>;
  updateCustomerOnCommit: () => void;
};

export const usePersonaliaForm = () => {
  const history = useHistory();
  const form = useForm<Values>({
    initialValues: {
      firstName: '',
      lastName: '',
      day: '',
      month: '',
      year: '',
      email: '',
      phoneNumber: ''
    },
    validations: {
      firstName: values => values.firstName.length > 0,
      lastName: values => values.lastName.length > 0,
      day: values => Number(values.day) > 0 && Number(values.day) < 32,
      month: values => Number(values.month) > 0 && Number(values.month) <= 12,
      year: values => Number(values.year) > 1900 && Number(values.year) <= 2300,
      email: values => isValidEmail(values.email),
      phoneNumber: values => isValidPhoneNumber(values.phoneNumber)
    }
  });

  const { state, dispatch } = useStore();
  const { packages, auth, address, sale, updateCustomer } = state;

  useEffect(() => {
    if (updateCustomer.status === RequestStatus.SUCCESS && sale.saleStatus === RequestStatus.INIT) {
      const selectedPackage: SalesPackage = packages.selectedPackage!;
      const customerId: number = packages.packages.customerId!;

      const saleDto: SalesDTO = {
        additionalProducts: packages.selectedAdditionalProducts.map(
          additionalProduct => additionalProduct.commercialProductId
        ),
        // TODO: Use actual customer id.
        customerId: customerId,
        packageId: selectedPackage.id
      };

      if (auth.token !== undefined) {
        commitSaleForCustomerAndAddress(saleDto, dispatch, auth.token);
      }
    }
    if (updateCustomer.status === RequestStatus.ERROR) {
      pushPageview('/feil');
      history.push('/feil');
    }
  }, [updateCustomer.status]);

  // If post to sale succeeded we go to booking page.
  useEffect(() => {
    if ([RequestStatus.SUCCESS].includes(sale.saleStatus)) {
      if (packages.selectedPackage) {
        pushTransaction([packages.selectedPackage], packages.selectedAdditionalProducts);
      }

      pushPageview(routes.receipt);
      history.push(routes.receipt);
    }
    if (RequestStatus.ERROR === sale.saleStatus) {
      pushPageview('/feil');
      history.push('/feil');
    }
  }, [sale.saleStatus]);

  const updateCustomerOnCommit = () => {
    if (packages.selectedPackage) {
      if (!form.hasFormFieldError) {
        const validAddressId = address.selectedAddress!.id;
        const { firstName, day, year, month, lastName, phoneNumber, email } = form.values;
        const updateCustomerDto: CustomerUpdateDTO = {
          customerId: packages.packages.customerId!,
          validAddressId: validAddressId,
          firstName,
          lastName,
          email,
          phoneNumber,
          dateOfBirth: day + ' ' + month + ' ' + year
        };

        updateCustomerInIcx(updateCustomerDto, dispatch);
      }
    }
  };
  return {
    form,
    updateCustomerOnCommit
  };
};
